/**
 * 锅体参数组件的共用逻辑 mixin
 * 用于 FirstPotParams 和 SecondPotParams 组件
 */
import {getProductParams} from "@/js/common";
import {getRecipeType} from "../utils";

// 菜谱类型常量
const RECIPE_TYPE = {
  "SOUP": {label: "汤机", value: "SOUP"},
  "AIR": {label: "空炸", value: "AIR_FRYER"},
  "STAND_MIXER": {label: "厨师机", value: "STAND_MIXER"},
  "OVEN": {label: "烤箱", value: "OVEN"},
};

export default {
  computed: {
    // 权限列表（从 store 获取）
    permissions() {
      const list = this.$store.getters.getProductModelByRecipeType || [];
      const productModels = this.$store.state.recipe?.products || [];
      const result = getProductParams(productModels, list);
      return Array.isArray(result) ? result.filter(p => p) : [];
    },

    // 食谱多类型拼接 如：汤机+空炸（SOUP_AND_AIR）
    multiTypeList() {
      if (!this.type) return [];
      let list = this.type.split("_AND_") || [];
      if (list.length < 2) return [];
      return list
        .map(key => RECIPE_TYPE[key])
        .filter(item => item && item.label && item.value);
    },

    // 是否空炸
    isAir() {
      return this.type === "AIR_FRYER" || this.stepPotType === "AIR_FRYER";
    },

    // 工作模式列表（根据类型过滤）
    modelList() {
      let type = getRecipeType(this.type);
      if (this.multiTypeList.length) type = this.stepPotType;
      const list = (this.workModelList || [])
        .filter(item => item && item.data === type);
      return this.filterModelByProduct(list);
    },

    // 计算分钟时间的函数
    minuteTime() {
      return function (time) {
        return parseInt((time / 60));
      };
    },

    // 是否禁用工作模式选择（需要组件有 disabled prop）
    wordModeDisabled() {
      if (this.disabled) return true;
      if (!this.multiTypeList.length) return false;
      return !this.stepPotType;
    }
  },
  methods: {
    // 根据所选型号过滤工作模式
    filterModelByProduct(list) {
      if (!list.length) return list;
      const productModelCodes = this.$store.state.recipe?.products || [];
      const brandOwnerProductList = this.$store.getters.getProductModelByRecipeType || [];
      const productModels = brandOwnerProductList
        .filter(item => item && productModelCodes.includes(item.productCode))
        .map(item => item.productModel)
        .filter(model => model);
      return list.filter(item => {
        if (!item || !item.products) return item;
        const products = item.products.split(",") || [];
        return productModels.length === 0 || productModels.every(model => products.includes(model));
      });
    },

    // 计算电机档位数的函数（需要子组件实现，因为需要访问不同的 rotateDirection）
    getMotorGearCount(rotateDirection) {
      return (data) => {
        if (!data) return 0;
        const {maxMotorGear, maxReverseMotorGear} = data;
        if (rotateDirection === '0') {
          return maxMotorGear + 1;
        } else if (rotateDirection === '1') {
          return maxReverseMotorGear + 1;
        }
        return 0;
      };
    }
  }
};

